import { render, staticRenderFns } from "./HotlinkRelative.vue?vue&type=template&id=39acbeb8&"
import script from "./HotlinkRelative.vue?vue&type=script&lang=js&"
export * from "./HotlinkRelative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports